import React from "react";

const index = () => {
  return (
    <div>
      <section className="privacyPolicy">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 col-sm-12">
              <div className="privacy_content">
                <h1>PRIVACY POLICY</h1>
                <p>
                  Tip Tax Finder operates www.tiptaxfinder.com (https://www.tiptaxfinder.com) as an
                  informational and referral website for the FICA tip tax
                  credit.We do not collect, store, or process any personal
                  information on this website beyond basic analytics.
                </p>
                <h3>1. Information We Collect Automatically</h3>
                <p>
                  When you visit our site, we (and our third-party analytics
                  providers) may collect limited, non-identifying information
                  such as:
                </p>
                <ul>
                  <li>IP address (anonymized)</li>
                  <li>Browser type, device type, and general location</li>
                  <li>Pages visited and time spent on site</li>
                </ul>
                <p>
                  This is done via cookies and tools like Google Analytics or
                  Plausible for the sole purpose of understanding site
                  performance.
                </p>
                <h3>2. No Forms or Direct Data Collection</h3>
                <p>
                  We do not have sign-up forms, contact forms that collect
                  names/emails (unless you add one later), or any place where
                  you upload payroll, tip, or employee data.
                </p>
                <h3>3. Referral Links</h3>
                <p>
                  When you click a link to our partner’s platform, you leave our
                  site entirely. Any information you provide on their website is
                  governed overned by their privacy policy, not ours.
                </p>
                <h3>4. Cookies & Analytics</h3>
                <p>
                  We use essential and analytics cookies. You can disable them
                  in your browser or via our cookie banner. We do not use
                  advertising or tracking cookies that sell or share your data.
                </p>
                <h3>5. We Do Not Sell Your Personal Information</h3>
                <h3>6. Your Privacy Rights</h3>
                <p>
                  Because we collect almost no personal information, most state
                  privacy rights (access, deletion, etc.) do not apply. If you
                  want us to delete analytics data tied to your visit, just
                  email us.
                </p>
                <h3>7. Contact Us</h3>
                <p>Questions? Email: Kaleesee@tiptaxfinder.com
</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default index;
